var render = function render(_c,_vm){return _c('el-tag',{attrs:{"type":_vm.$options.checkType(_vm.props.row[_vm.props.column])}},[_vm._v(_vm._s(_vm.props.row[_vm.props.column])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }